import type { ReactNode } from "react";
import { View } from "react-native";
import { Gap, Padding, Rounded, Width } from "~/constants/layout";
import { useTheme } from "~/providers/ThemeProvider";

type GuestFieldGroupProps = {
    children: ReactNode;
};

export const GuestFieldGroup = ({ children }: GuestFieldGroupProps) => {
    const { background } = useTheme();

    return <View style={[Rounded.lg, Width.full, Gap.lg, Padding.lg, background.primary]}>{children}</View>;
};
